/* DEMONS & MACHINES — comportamiento global
   header transparente → sólido al scrollear · menús desktop al hover · back to top ·
   navegación y barra de progreso de sliders · estado de carga de imágenes */
(function () {
  'use strict';
  const mqDesktop = window.matchMedia('(min-width: 1068px)');

  /* ---------- Header ---------- */
  const headerSection = document.querySelector('.section-header');
  const headerWrapper = document.querySelector('.header-wrapper');
  const transparent = document.body.classList.contains('dm-header-transparent');

  function updateHeaderState() {
    if (!headerWrapper) return;
    const scrolled = window.scrollY > 40;
    const open = !!headerWrapper.querySelector('header-menu details[open]');
    headerWrapper.classList.toggle('dm-header-wrapper--solid', !transparent || scrolled || open);
  }
  updateHeaderState();
  window.addEventListener('scroll', updateHeaderState, { passive: true });

  // apertura al hover en desktop (Dawn abre al click)
  if (headerWrapper) {
    headerWrapper.querySelectorAll('header-menu > details').forEach((details) => {
      let timer;
      const parent = details.parentElement;
      parent.addEventListener('mouseenter', () => {
        if (!mqDesktop.matches) return;
        clearTimeout(timer);
        details.open = true;
        details.querySelector('summary')?.setAttribute('aria-expanded', 'true');
        updateHeaderState();
      });
      parent.addEventListener('mouseleave', () => {
        if (!mqDesktop.matches) return;
        timer = setTimeout(() => {
          details.open = false;
          details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
          updateHeaderState();
        }, 120);
      });
      details.addEventListener('toggle', updateHeaderState);
    });
  }

  /* ---------- Back to top ---------- */
  const btt = document.querySelector('.dm-back-to-top');
  if (btt) {
    const toggle = () => btt.classList.toggle('is-active', window.scrollY > 600);
    toggle();
    window.addEventListener('scroll', toggle, { passive: true });
    btt.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  }

  /* ---------- Sliders: flechas circulares + barra de progreso ---------- */
  function enhanceSlider(root) {
    const slider = root.querySelector('.slider');
    if (!slider || root.dataset.dmEnhanced) return;
    root.dataset.dmEnhanced = '1';
    const items = Array.from(slider.querySelectorAll('.slider__slide'));
    if (items.length < 2) return;

    // flechas, centradas sobre la imagen (data-dm-arrow-anchor: selector dentro del slide)
    const nav = document.createElement('div');
    nav.className = 'dm-slider-nav';
    nav.innerHTML =
      '<button type="button" class="dm-slider-nav__btn dm-slider-nav__btn--prev" aria-label="Anterior"><svg viewBox="0 0 15 11" fill="none" stroke="currentColor" stroke-width="1.2"><path d="M6 1 1 5.5 6 10M1 5.5h13"/></svg></button>' +
      '<button type="button" class="dm-slider-nav__btn dm-slider-nav__btn--next" aria-label="Siguiente"><svg viewBox="0 0 15 11" fill="none" stroke="currentColor" stroke-width="1.2"><path d="m9 1 5 4.5L9 10M14 5.5H1"/></svg></button>';
    const sliderWrap = slider.parentElement;
    sliderWrap.style.position = 'relative';
    sliderWrap.appendChild(nav);
    const prev = nav.querySelector('.dm-slider-nav__btn--prev');
    const next = nav.querySelector('.dm-slider-nav__btn--next');

    const anchorSel = root.dataset.dmArrowAnchor || '.card__media, .media, img';
    function positionArrows() {
      const anchor = items[0].querySelector(anchorSel) || items[0];
      const top = anchor.getBoundingClientRect().top - sliderWrap.getBoundingClientRect().top + anchor.offsetHeight / 2;
      nav.style.top = top + 'px';
    }

    // progreso
    let progress = root.querySelector('.dm-slider-progress');
    if (!progress && root.dataset.dmProgress !== 'false') {
      progress = document.createElement('div');
      progress.className = 'dm-slider-progress';
      progress.innerHTML = '<div class="dm-slider-progress__bar"></div>';
      sliderWrap.insertAdjacentElement('afterend', progress);
    }
    const bar = progress ? progress.querySelector('.dm-slider-progress__bar') : null;

    function step() { return items[1].offsetLeft - items[0].offsetLeft || items[0].offsetWidth; }
    function update() {
      const max = slider.scrollWidth - slider.clientWidth;
      const x = slider.scrollLeft;
      prev.disabled = x <= 2;
      next.disabled = x >= max - 2;
      if (bar) {
        const visible = Math.max(slider.clientWidth / slider.scrollWidth, 0.08);
        bar.style.width = visible * 100 + '%';
        bar.style.transform = 'translateX(' + (max > 0 ? (x / max) * (100 / visible - 100) : 0) + '%)';
      }
      positionArrows();
    }
    prev.addEventListener('click', () => slider.scrollBy({ left: -step(), behavior: 'smooth' }));
    next.addEventListener('click', () => slider.scrollBy({ left: step(), behavior: 'smooth' }));
    slider.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(update);
    setTimeout(update, 50);
    setTimeout(update, 600);
  }
  function enhanceAll() { document.querySelectorAll('.dm-slider').forEach(enhanceSlider); }
  enhanceAll();
  document.addEventListener('shopify:section:load', enhanceAll);

  /* ---------- Placeholders del editor: que recorten (slice) en vez de estirarse ---------- */
  document.querySelectorAll('svg.placeholder-svg').forEach((svg) => svg.setAttribute('preserveAspectRatio', 'xMidYMid slice'));

  /* ---------- Imágenes: estado cargado ---------- */
  function markLoaded(img) { img.classList.add('is-loaded'); }
  document.querySelectorAll('img.dm-lazy').forEach((img) => {
    if (img.complete && img.naturalWidth) markLoaded(img);
    else img.addEventListener('load', () => markLoaded(img), { once: true });
  });

  /* ---------- Dots genéricos (secciones con data-dm-dots) ---------- */
  document.querySelectorAll('[data-dm-dots]').forEach((wrap) => {
    const slider = wrap.querySelector('.slider');
    const dots = wrap.querySelectorAll('.dm-dots__dot');
    if (!slider || !dots.length) return;
    const slides = slider.querySelectorAll('.slider__slide');
    dots.forEach((d, i) => d.addEventListener('click', () => slides[i] && slider.scrollTo({ left: slides[i].offsetLeft - slider.offsetLeft, behavior: 'smooth' })));
    slider.addEventListener('scroll', () => {
      const i = Math.round(slider.scrollLeft / (slides[1] ? slides[1].offsetLeft - slides[0].offsetLeft : slider.clientWidth));
      dots.forEach((d, j) => d.setAttribute('aria-current', j === i ? 'true' : 'false'));
    }, { passive: true });
  });
})();

/* ---------- Vistos recientemente: el PDP guarda su handle (máx. 12) ---------- */
(function () {
  try {
    const m = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!m) return;
    const h = decodeURIComponent(m[1]); const k = 'dm_recent';
    let l = JSON.parse(localStorage.getItem(k) || '[]');
    l = [h].concat(l.filter((x) => x !== h)).slice(0, 12);
    localStorage.setItem(k, JSON.stringify(l));
  } catch (e) {}
})();
